var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.702,
    cy: 29.5006,
    r: 29.1981,
    fill: "#FFF5E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5813 14.5053L29.7006 13.4259L39.8198 14.5053L47.655 25.1022L29.7006 46.1732L11.7461 25.1022L19.5813 14.5053Z",
    fill: "#FDB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0191 25.1022L29.7006 46.1733L11.7461 25.1022H19.0191Z",
    fill: "#EA6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3846 25.1022L29.7031 46.1733L47.6576 25.1022H40.3846Z",
    fill: "#EA6C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0234 25.1022H40.3863L29.7049 46.1733L19.0234 25.1022Z",
    fill: "#FDAD00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7049 13.4259L19.5856 14.5053L19.0234 25.1022L29.7049 13.4259Z",
    fill: "#FDD231"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7031 13.4259L39.8224 14.5053L40.3846 25.1022L29.7031 13.4259Z",
    fill: "#FDD231"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6594 25.1021L39.8242 14.5053L40.3864 25.1021H47.6594Z",
    fill: "#FDAD00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7049 13.4259L19.0234 25.1022H40.3863L29.7049 13.4259Z",
    fill: "#FEEEB7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7461 25.1021L19.5813 14.5053L19.0191 25.1021H11.7461Z",
    fill: "#FDAD00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/Sketch.f16945f46be61df746463fe73a2c4841.svg";
export { ForwardRef as ReactComponent };